import FaceBookSocialMedia from "../../../../../Assets/Image/Footer/FaceBookSocialMedia.svg";
import IGSocialMedia from "../../../../../Assets/Image/Footer/IGSocialMedia.svg";
import YouTubeSocialMedia from "../../../../../Assets/Image/Footer/YouTubeSocialMedia.svg";
import LineSocialMedia from "../../../../../Assets/Image/Footer/LineSocialMedia.svg";
import {
  FooterSocialMediaWrapper,
  FooterSocialMediaLogo,
  FooterSocialLink
} from "./FooterSocialMediaStyled";

const FooterSocialMedia = () => {
  const socialMedias = [
    { src: FaceBookSocialMedia, link: "https://www.facebook.com/UnicityThailand/" },
    { src: IGSocialMedia, link: "https://www.instagram.com/unicity_thailand/" },
    { src: YouTubeSocialMedia, link: "https://www.youtube.com/user/MKTunicity" },
    { src: LineSocialMedia, link: "https://page.line.me/unicity?openQrModal=true" },
  ];
  return (
    <FooterSocialMediaWrapper>
      {socialMedias.map((socialMedia,index) => (
        <FooterSocialLink key={index} href={socialMedia.link} target="_blank" rel="noreferrer">
          <FooterSocialMediaLogo src={socialMedia.src} />
        </FooterSocialLink>
      ))}
    </FooterSocialMediaWrapper>
  );
};

export default FooterSocialMedia;
